module.exports = __webpack_public_path__ + "img/new_logo.ae867793.svg";